import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import zh from './locales/zh.json';
import de from './locales/de.json';
import pt from './locales/pt.json';
import tr from './locales/tr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import ar from './locales/ar.json';
import id from './locales/id.json';
import ms from './locales/ms.json';
import vi from './locales/vi.json';
import fr from './locales/fr.json';
import el from './locales/el.json';
import cs from './locales/cs.json';
import nl from './locales/nl.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    pt: { translation: pt },
    tr: { translation: tr },
    es: { translation: es },
    it: { translation: it },
    zh: { translation: zh },
    ar: { translation: ar },
    id: { translation: id },
    ms: { translation: ms },
    vi: { translation: vi },
    fr: { translation: fr },
    el: { translation: el },
    cs: { translation: cs },
    nl: { translation: nl },
  },
  lng: 'fr',
  fallbackLng: 'fr',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
